import React, { useEffect } from "react";
import { Alert, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAssessment } from "./AssessmentProvider";

/**
 * RequireAssessment
 * Workspace screens depend on a selected assessment.
 * If none is selected, guide the user to the Assessments list.
 */
export function RequireAssessment({ children }: { children: React.ReactNode }) {
  const nav = useNavigate();
  const { selectedId, loading, assessments, setSelectedId } = useAssessment();

  useEffect(() => {
    // Auto-select if there's exactly one assessment (nice UX for demos)
    if (!loading && !selectedId && assessments.length === 1) {
      setSelectedId(assessments[0].id);
    }
  }, [loading, selectedId, assessments, setSelectedId]);

  if (loading && !selectedId) return null;

  if (!selectedId) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert
          severity="info"
          action={
            <Button color="inherit" size="small" onClick={() => nav("/assessments")}>
              Choose
            </Button>
          }
        >
          Please select a risk assessment to continue.
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
}
